import React, { useEffect, useState } from "react";
import { Carousel, Row, Col, FloatButton, Empty } from "antd";
import { FaPlus } from "react-icons/fa";
import { settingsService } from "../../services/settingsService";
import Loading from "../../components/common/Loading/Loading";
import DoctorCard from "../../components/Home/DoctorCard/DoctorCard";
import BookingModal from "../../components/Home/BookingModal/BookingModal";
import styles from "./Home.module.css";

const Home = () => {
  const [banners, setBanners] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [hospital, setHospital] = useState(null);
  const [loading, setLoading] = useState(true);
  const [bookingOpen, setBookingOpen] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [bannersData, doctorsData, hospitalsData] = await Promise.all([
          settingsService.getBanners(),
          settingsService.getDoctors(),
          settingsService.getHospitals(),
        ]);
        setBanners(bannersData);
        setDoctors(doctorsData);
        // Portal 1 cơ sở: lấy bản ghi đầu làm mặc định
        setHospital(hospitalsData[0] ?? null);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const handleBook = (doctor) => {
    setSelectedDoctor(doctor || null);
    setBookingOpen(true);
  };

  const handleOpenBooking = () => {
    setSelectedDoctor(null);
    setBookingOpen(true);
  };

  const handleCloseBooking = () => {
    setBookingOpen(false);
  };

  if (loading) {
    return (
      <div className={styles.loadingWrap}>
        <Loading tip="Đang tải dữ liệu..." fullScreen={false} />
      </div>
    );
  }

  return (
    <div>
      {/* Hero Banner */}
      {banners.length > 0 && (
        <div className={styles.heroBanner}>
          <Carousel autoplay autoplaySpeed={6000} dots>
            {banners.map((banner) => {
              const slide = (
                <div className={styles.slide}>
                  <img
                    src={banner.image}
                    alt={banner.title || "Banner"}
                    className={styles.slideImg}
                  />
                </div>
              );

              return (
                <div key={banner.id}>
                  {/* Có link -> cho bấm mở link */}
                  {banner.linkUrl ? (
                    <a
                      href={banner.linkUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.slideLink}
                    >
                      {slide}
                    </a>
                  ) : (
                    slide
                  )}
                </div>
              );
            })}
          </Carousel>
        </div>
      )}

      {/* Doctor list */}
      <div className={styles.pageContainer}>
        <div className={styles.doctorSection}>
          <h2 className={styles.sectionHeading}>Đội ngũ bác sỹ</h2>
          {doctors.length > 0 ? (
            <Row gutter={[16, 16]} align="stretch">
              {doctors.map((doctor) => (
                <Col
                  key={doctor.id}
                  xs={12}
                  sm={12}
                  md={8}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <DoctorCard doctor={doctor} onBook={handleBook} />
                </Col>
              ))}
            </Row>
          ) : (
            <Empty description="Chưa có thông tin bác sỹ" />
          )}
        </div>
      </div>

      {/* Floating CTA */}
      <FloatButton
        type="primary"
        icon={<FaPlus />}
        description="Đăng ký"
        shape="square"
        style={{
          right: 24,
          bottom: 32,
          width: 64,
          height: 64,
          boxShadow: "0 4px 16px rgba(22,163,74,0.45)",
        }}
        onClick={handleOpenBooking}
        tooltip="Đăng ký khám"
      />

      <BookingModal
        open={bookingOpen}
        onClose={handleCloseBooking}
        doctors={doctors}
        selectedDoctor={selectedDoctor}
        hospital={hospital}
      />
    </div>
  );
};

export default Home;
